const STORE_ACCESS_TOKEN = '6fd1a386f79d47fcd0db69359f86e72c'; // Storefront API トークン

// 現在のログインユーザーの ID（`customerAccessToken` の代わり）
async function getCustomerAccessTokenFromSession() {
    const response = await fetch('/account.json', {
        method: 'GET',
        credentials: 'include', // クッキーを送信
        headers: {
            'Accept': 'application/json'
        }
    });

    const data = await response.json();
    console.log("現在のログインユーザー:", data); // ユーザー情報を確認

    if (data && data.customer && data.customer.id) {
        return data.customer.id;
    }

    console.error("顧客がログインしていません。");
    return null;
}

// お気に入りリストを取得
async function getFavorites() {
    const customerAccessToken = await getCustomerAccessTokenFromSession();
    if (!customerAccessToken) {
        console.error("❌ 顧客がログインしていません。お気に入りを取得できません。");
        return { articles: [] };
    }

    console.log("✅ 取得する顧客ID:", customerAccessToken); // 顧客IDの確認

    const response = await fetch('/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': STORE_ACCESS_TOKEN
        },
        body: JSON.stringify({
            query: `
                {
                    customer(customerAccessToken: "${customerAccessToken}") {
                        metafield(namespace: "custom", key: "blog_favorites") {
                            value
                        }
                    }
                }
            `
        })
    });

    const textResponse = await response.text(); // レスポンスをテキストで取得
    console.log("📡 APIレスポンス:", textResponse); // レスポンスの確認

    try {
        const jsonData = JSON.parse(textResponse);
        console.log("✅ お気に入り取得:", jsonData);

        if (jsonData.errors) {
            console.error("❌ APIエラー:", jsonData.errors);
            return { articles: [] };
        }

        return JSON.parse(jsonData.data.customer.metafield.value);
    } catch (error) {
        console.error("❌ JSONの解析に失敗。HTMLが返っている可能性:", error, textResponse);
        return { articles: [] };
    }
}

// お気に入りリストを更新
async function updateFavorites(newFavorites) {
    const customerAccessToken = await getCustomerAccessTokenFromSession();
    if (!customerAccessToken) return;

    console.log("🚀 更新するお気に入りリスト:", newFavorites);

    const response = await fetch('/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': STORE_ACCESS_TOKEN
        },
        body: JSON.stringify({
            query: `
                mutation {
                    customerUpdate(input: {
                        customerAccessToken: "${customerAccessToken}",
                        metafields: {
                            namespace: "custom",
                            key: "blog_favorites",
                            value: "${JSON.stringify(newFavorites)}",
                            type: "json_string"
                        }
                    }) {
                        userErrors {
                            field
                            message
                        }
                    }
                }
            `
        })
    });

    const data = await response.json();
    console.log("✅ お気に入り更新APIレスポンス:", data);

    if (data.errors) {
        console.error("❌ お気に入り更新エラー:", data.errors);
    }
}

// お気に入りボタンをセットアップ
document.addEventListener("DOMContentLoaded", async function() {
    const buttons = document.querySelectorAll(".wishlist-btn");
    let favorites = await getFavorites();

    buttons.forEach(button => {
        const articleId = button.getAttribute("data-article-id");

        // 初期状態を設定（お気に入り済みかチェック）
        if (favorites.articles.includes(articleId)) {
            button.innerText = "💔 お気に入り解除";
            button.classList.add("active");
        } else {
            button.innerText = "❤️ お気に入り登録";
            button.classList.remove("active");
        }

        button.addEventListener("click", async function() {
            if (favorites.articles.includes(articleId)) {
                favorites.articles = favorites.articles.filter(id => id !== articleId);
                button.innerText = "❤️ お気に入り登録";
                button.classList.remove("active");
            } else {
                favorites.articles.push(articleId);
                button.innerText = "💔 お気に入り解除";
                button.classList.add("active");
            }

            console.log("更新後のお気に入り:", favorites);

            await updateFavorites(favorites);

            // 最新のデータを取得してUIを更新
            let updatedFavorites = await getFavorites();
            console.log("更新後の取得データ:", updatedFavorites);

            if (updatedFavorites.articles.includes(articleId)) {
                button.innerText = "💔 お気に入り解除";
                button.classList.add("active");
            } else {
                button.innerText = "❤️ お気に入り登録";
                button.classList.remove("active");
            }
        });
    });
});